/**
 * Utility function to safely parse card message JSON on frontend
 * Handles both string and object formats
 */
export const parseCardMessage = (cardMessage: any): any => {
  if (!cardMessage) {
    return {};
  }

  // If it's already an object, return it
  if (typeof cardMessage === 'object') {
    return cardMessage;
  }

  // If it's a string, try to parse it
  if (typeof cardMessage === 'string') {
    try {
      return JSON.parse(cardMessage);
    } catch (error) {
      console.error('Error parsing cardMessage JSON:', error);
      return {};
    }
  }

  return {};
};

/**
 * Utility function to safely stringify card message on frontend
 */
export const stringifyCardMessage = (cardMessage: any): string => {
  try {
    return JSON.stringify(cardMessage);
  } catch (error) {
    console.error('Error stringifying cardMessage:', error);
    return '{}';
  }
};

export default {
  parseCardMessage,
  stringifyCardMessage,
};
